import React from 'react';

import { Chip, ChipProps, CircularProgress } from '@mui/material';

import { HeroPlannerDebugPreSendCheck } from '~/hooks/apis/customer-communication/useHeroPlannerScheduleDebug';

import {
  getHeroPlannerDebugPreSendCheckName,
  isHeroPlannerDebugPreSendCheckPassing,
} from '../../utils/heroPlannerDebugUtils';

interface Props {
  check: HeroPlannerDebugPreSendCheck;
}

function HeroPlannerDebugPreSendCheckChip({ check }: Props) {
  const { query } = check;
  const name = getHeroPlannerDebugPreSendCheckName(check.segment);

  let chipProps: Pick<ChipProps, 'label' | 'color' | 'icon'>;
  if (query.isPending || query.isFetching) {
    chipProps = { label: `${name}: checking`, icon: <CircularProgress size={12} /> };
  } else if (query.isError) {
    chipProps = { label: `${name}: couldn't run`, color: 'warning' };
  } else if (isHeroPlannerDebugPreSendCheckPassing(query.data)) {
    chipProps = { label: `${name}: pass`, color: 'success' };
  } else {
    chipProps = { label: `${name}: ${query.data.status.toLowerCase().replace(/_/g, ' ')}`, color: 'error' };
  }

  return <Chip size="small" variant="outlined" {...chipProps} />;
}

export default HeroPlannerDebugPreSendCheckChip;
